export default __webpack_public_path__ + "assets/images/bajajCareAppQR.e12ba58ebfbf4dbd2d1cca29429acbf6.png";